import { generatePath } from "react-router-dom";

import { ChangeServiceStatus } from "@/changeservice/misc/changeServiceStatus";

const baseUrl = `/mein-remindme/wechselservice`;
export const baseRoute = "/mein-remindme/wechselservices";
export const documentSubRoute = "/dokumente";
export const detailSubRoute = "/detail";
export const historySubRoute = "/historie";
export const EditSubRoute = "/bearbeiten";
export const tariffSubRoute = "/tariff";

export const deactivateRoute = `${baseUrl}/:category/deactivate/:id`;
export const getDeactivateRoute = (category: string, id: string) => generatePath(deactivateRoute, { category, id });

export const withdrawalRoute = `${baseUrl}/:category/withdrawal/:id`;
export const getWithdrawalRoute = (category: string, id: string) => generatePath(withdrawalRoute, { category, id });

export const detailRoute = `${baseUrl}/:category/detail/:id`;
export const getDetailRoute = (category: string, id: string) => generatePath(detailRoute, { category, id });

export const editRoute = `${baseUrl}/:category/bearbeiten/:id`;
export const getEditRoute = (category: string, id: string) => generatePath(editRoute, { category, id });

export const tariffRoute = `${baseUrl}/:category/tariff/:id`;
export const getTariffRoute = (category: string, id: string) => generatePath(tariffRoute, { category, id });

export const FaqBaseRoute = "/fragen-und-antworten";
export const FaqBaseRedirectRoute = "/fragen-und-antworten/wechselablauf";

export const baseMissingDataRoute = "/fehlendedaten";
export const MissingDataRoute = "/fehlendedaten/:category/:changeServiceId";
export const MissingContractEndDateRoute = "/fehlendesvertragsende/:category/:changeServiceId";
export const getMissingDataRoute = (category: string, changeServiceId: string) =>
  generatePath(MissingDataRoute, { category, changeServiceId });

export const SleepingCustomerRoute = "/fehlendedaten/:category/sc/:tariffId";
export const getSleepingCustomerRoute = (category: string, tariffId: string) => generatePath(SleepingCustomerRoute, { category, tariffId });

export const verifyRoute = `${baseUrl}/:category/daten-ergaenzen"/:id`;
export const getVerifyRoute = (category: string, id: string) => generatePath(verifyRoute, { category, id });

export const ContactRoute = "/kontakt";

export const documentsRoute = `${baseUrl}/:category/dokumente/:id`;
export const getDocumentsRoute = (category: string, id: string) => generatePath(documentsRoute, { category, id });

export const historyRoute = `${baseUrl}/:category/historie/:id`;
export const getHistoryRoute = (category: string, id: string) => generatePath(historyRoute, { category, id });

const ctaButtonLinkHandlers = {
  [ChangeServiceStatus.PENDING_USER_ACTIVATION]: FaqBaseRedirectRoute,
  [ChangeServiceStatus.DEACTIVATED]: getEditRoute,
  [ChangeServiceStatus.MISSING_DATA]: getMissingDataRoute,
  [ChangeServiceStatus.TC_WITHDRAWN]: ContactRoute,
  [ChangeServiceStatus.INCORRECT_DATA]: getVerifyRoute,
  [ChangeServiceStatus.INCORRECT_DATA_RESPONSE_AVAILABLE]: getEditRoute,
  [ChangeServiceStatus.DATA_CHECK]: getEditRoute,
  [ChangeServiceStatus.EOD]: getEditRoute,
  [ChangeServiceStatus.EOD_RESPONSE_AVAILABLE]: getEditRoute,
  [ChangeServiceStatus.READY_TO_CHANGE]: getEditRoute,
  [ChangeServiceStatus.READY_TO_CHANGE_NEW]: getEditRoute,
  [ChangeServiceStatus.TC_DENIED]: getEditRoute,
  [ChangeServiceStatus.TC_SUCCESSFUL_WAITING_FOR_PROVIDER]: getEditRoute,
  [ChangeServiceStatus.TC_WAITING_FOR_AUTOMATION]: getEditRoute,
  [ChangeServiceStatus.NEW]: getEditRoute,
  [ChangeServiceStatus.MANAGED_BY_SALES]: getEditRoute,
};

export const getCsDetailsRouteLink = (status?: string, categorySlug?: string, csId?: string, tariffId?: string) => {
  if (!status) return "#";
  const routeHandler = ctaButtonLinkHandlers[status];
  if (typeof routeHandler !== "function") return routeHandler || "#";
  if (categorySlug && tariffId && status === ChangeServiceStatus.READY_TO_CHANGE)
    return getTariffRoute(categorySlug, tariffId);
  if (categorySlug && csId) return routeHandler(categorySlug, csId);
};
